import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Modal, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { PencilIcon } from '@primer/octicons-react'
import { BiPlus, BiTrash } from "react-icons/bi";
import { SearchIcon } from '@primer/octicons-react';
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { formatDate } from '../utils/timeUtils';
import { testJSON } from '../utils/jsUtils';


const SubsAdminDetailsView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [subsAttrs, setSubsAttrs] = useState({
    subsApp: '',
    description: '',
    igcUsername: '',
    receiverType: '',
    receiverUsername: '',
    receiverPassword: '',
    receiverSetting: '',
    status: '',
    creatorUsername: '',
    timeCreated: '',
    updaterUsername: '',
    timeUpdated: ''
  });

  const [origSubsAttrs, setOrigSubsAttrs] = useState({});

  // ##### Needs to be fetch through API #####

  const statusOptions = [
    { key: "SUBS_ST_ACTIVE",    value: "SUBS_ST_ACTIVE" },
    { key: "SUBS_ST_SUSPENDED", value: "SUBS_ST_SUSPENDED" },
    { key: "SUBS_ST_STOPPED",   value: "SUBS_ST_STOPPED" }
  ];

  const receiverTypeOptions = [
    { key: "MQTT",      value: "MQTT" },
    { key: "WEBSOCKET", value: "WEBSOCKET" },
    { key: "RESTAPI",   value: "RESTAPI" }
  ];


  // -- View vs Edit Modes --
  const [editMode, setEditMode] = useState(false);

  const [errMsg,             setErrMsg]             = useState('');
  const [errMsg_Update,      setErrMsg_Update]      = useState('');

  // -- Subs Target (Datapoint vs Alarm Type) Modes --
  const [subsTargetMode, setSubsTargetMode] = useState('DATAPOINTS');

  const handleTargetToggle = (subsTarget, e) => {
    setSubsTargetMode(subsTarget);
  }

  // -- DATAPOINT --
  const [datapointList, setDatapointList] = useState([]);

  //const [showDatapointInfo, setShowDatapointInfo] = useState(false);
  //const [datapointSelected, setDatapointSelected] = useState();

  const [datapointCandidateList, setDatapointCandidateList] = useState([]);
  const [datapointAddList, setDatapointAddList] = useState([]);

  const [showAddDatapointDialog, setShowAddDatapointDialog] = useState(false);
  const [addDatapointErrMsg, setAddDatapointErrMsg] = useState('');

  // -- ALARM RULE --
  const [alarmRuleList, setAlarmRuleList] = useState([]);

  //const [showAlarmRuleInfo, setShowAlarmRuleInfo] = useState(false);
  //const [alarmRuleSelected, setAlarmRuleSelected] = useState();

  const [alarmRuleCandidateList, setAlarmRuleCandidateList] = useState([]);
  const [alarmRuleAddList, setAlarmRuleAddList] = useState([]);

  const [showAddAlarmRuleDialog, setShowAddAlarmRuleDialog] = useState(false);
  const [addAlarmRuleErrMsg, setAddAlarmRuleErrMsg] = useState('');


  // -- Searching --
  const [newSearchTerm, setSearchTerm] = useState(
    { searchTerm: '' }
  );

  var { searchTerm } = newSearchTerm;

  const onSearchInputChange = (e) => {
    setSearchTerm({ ...searchTerm, [e.target.name]: e.target.value });
  }

  const handleSearchDatapointsSubmit = (e) => {
    e.preventDefault();

    searchDatapoints(searchTerm, false);
  }

  const handleSearchAlarmRulesSubmit = (e) => {
    e.preventDefault();

    searchAlarmRules(searchTerm, false);
  }

  const searchDatapoints = (searchTerm) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("datapoints?searchTerms=" + searchTerm + "&searchField=CODE");

        resolve(res.data);

        if ((res.status === 200) && res.data && (res.data.total > 0)) {

          const rawData = res.data.data;

          // Remove already subscribbed
          let codeArray = [];
          for (let i=0; i<datapointList.length; i++) {
            codeArray.push(datapointList[i].code);
          }

          let newArray = [];
          for (let i=0; i<rawData.length; i++) {
            if (!codeArray.includes(rawData[i].code)) {
              newArray.push(rawData[i]);
            }
          }

          setDatapointCandidateList(newArray);
        }

        setAddDatapointErrMsg('');
      } catch (error) {
        setAddDatapointErrMsg(t(translateAPIError(error)));
      }
    });
  }

  const searchAlarmRules = (searchTerm) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("alarm-rules?searchTerms=" + searchTerm);

        resolve(res.data);

        if ((res.status === 200) && res.data && (res.data.total > 0)) {

          const rawData = res.data.data;

          // Remove alarm types subscribbed
          let codeArray = [];
          for (let i=0; i<alarmRuleList.length; i++) {
            codeArray.push(alarmRuleList[i].code);
          }

          let newArray = [];
          for (let i=0; i<rawData.length; i++) {
            if (!codeArray.includes(rawData[i].code)) {
              newArray.push(rawData[i]);
            }
          }

          setAlarmRuleCandidateList(newArray);
        }

        setAddAlarmRuleErrMsg('');
      } catch (error) {
        setAddAlarmRuleErrMsg(t(translateAPIError(error)));
      }
    });
  }


  // UI Functions

  // Initialize status
  useEffect(() => {
    if (props) {
      setSubsAttrsWithFormatting (props.objDetails);
      setOrigSubsAttrs(props.jobDetails);

      fetchAssociatedDatapoints(props.objDetails.id);
      fetchAssociatedAlarmRules(props.objDetails.id);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  const setSubsAttrsWithFormatting = (objDetails) => {
      // Properly format receiver settings JSON
      // Makes a deep copy
      let inputSubDetails = JSON.parse (JSON.stringify (objDetails));

      inputSubDetails.receiverSetting = JSON.stringify(objDetails.receiverSetting, undefined, 4);

      setSubsAttrs(inputSubDetails);
  }


  const fetchAssociatedDatapoints = (subsId) => {

    if (!subsId) {
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("subs/" + subsId + "/datapoint-ids");

        resolve(res.data);

        if (res.status === 200) {
          setDatapointList(res.data);
        }

        setErrMsg('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }

  const fetchAssociatedAlarmRules = (subsId) => {

    if (!subsId) {
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("subs/" + subsId + "/alarmrule-ids");

        resolve(res.data);

        if (res.status === 200) {
          setAlarmRuleList(res.data);
        }

        setErrMsg('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }




  const handleEditAttrs = (e) => {
    e.preventDefault();
    setEditMode(true);
  }


  const onAttrsInputChange = (e) => {
    setSubsAttrs({ ...subsAttrs, [e.target.name]: e.target.value })
  }

  const onStatusSelect = (key, event) => {
    setSubsAttrs({ ...subsAttrs, status: key })
  };

  const onReceiverTypeSelect = (key, event) => {
    setSubsAttrs({ ...subsAttrs, receiverType: key })
  };

  const handleEditCancel = (e) => {
    e.preventDefault();

    // Reset fields
    setSubsAttrsWithFormatting(origSubsAttrs);

    setEditMode(false);
  }

  const handleEditSubmit = (e) => {
    e.preventDefault();

    // Validate form inputs
    if (!subsAttrs.subsApp || subsAttrs.subsApp.trim().length === 0) {
      // ##### NEED TO CHECK NAME DUPLICTION #####
      setErrMsg_Update(t("I18N_ERR_Need_subs_app"));
      return;
    } else if (subsAttrs.subsApp.length > 50) {
      setErrMsg_Update(t("I18N_ERR_Max_len_subs_app") + 50);
      return;
    } else if (subsAttrs.description.length > 200) {
      setErrMsg_Update(t("I18N_ERR_Max_len_desc") + 200);
      return;
    } else if (!subsAttrs.igcUsername || subsAttrs.igcUsername.trim().length === 0) {
      setErrMsg_Update(t("I18N_ERR_Need_IGC_username"));
      return;
    } else if (subsAttrs.igcUsername.length > 60) {
      setErrMsg_Update(t("I18N_ERR_Max_len_igc_uname") + 60);
      return;
    } else if (subsAttrs.receiverType === '') {
      setErrMsg_Update(t("I18N_ERR_Need_Receiver_type"));
      return;
/*
    } else if (subsAttrs.receiverUsername === '') {
      setErrMsg_Update(t("I18N_ERR_Need_Receiver_username"));
      return;
*/
    } else if (subsAttrs.receiverUsername.length > 50) {
      setErrMsg_Update(t("I18N_ERR_Max_len_rec_uname") + 50);
      return;
/*
    } else if (subsAttrs.receiverPassword === '') {
      setErrMsg_Update(t("I18N_ERR_Need_Receiver_password"));
      return;
*/
    } else if (subsAttrs.receiverPassword.length > 50) {
      setErrMsg_Update(t("I18N_ERR_Max_len_rec_pwd") + 50);
      return;
    } else if (subsAttrs.receiverSetting === '') {
      setErrMsg_Update(t("I18N_ERR_Need_Receiver_setting"));
      return;
    } else if (   subsAttrs.receiverSetting
               && (subsAttrs.receiverSetting !== '')
               && (!testJSON(subsAttrs.receiverSetting))) {
      // Validate configuration to be valid JSON
      setErrMsg_Update(t("I18N_ERR_Rec_set_need_valid_JSON"));
      return;
    } else if (subsAttrs.status === '') {
      setErrMsg_Update(t("I18N_ERR_Need_status"));
      return;
    }

    // Make a deep copy
    const reqBody = JSON.parse(JSON.stringify(subsAttrs));
    reqBody.receiverSetting = JSON.parse(subsAttrs.receiverSetting.trim());

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.put("subs/" + subsAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {

          // Restore UI to viewing mode
          setEditMode(false);
          setErrMsg_Update('');

          fetchObj(subsAttrs.id);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_Update(t(translateAPIError(error)));
        }
      }
    });

  }

  const fetchObj = (id) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("subs/" + id);

        resolve(res.data);

        if (res.status === 200) {
          setSubsAttrsWithFormatting(res.data[0]);
          setOrigSubsAttrs(res.data[0]);
        }

        setErrMsg_Update('');
      } catch (error) {
        setErrMsg_Update(t(translateAPIError(error)));
      }
    });
  }


  const handleClose = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  // -- DATAPOINTS --

/*
  function handleDatapointInfo(datapoint) {

    setDatapointSelected(datapoint);
    setShowDatapointInfo(true);
  }

  const handleDatapointInfoClose = (e) => {
    setDatapointSelected(null);
    setShowDatapointInfo(false);
  }
*/


  function handleAddDatapoints() {
    //searchDatapoints();
    setShowAddDatapointDialog(true);
  }

  function handleAddDatapointsClose() {
    setSearchTerm('');
    setDatapointAddList([]);
    setShowAddDatapointDialog(false);
  }

  function handleAddDatapointsSubmit() {
    let datapointIds = [];

    if (datapointAddList.length === 0) {
      setShowAddDatapointDialog(false);
      return;
    }

    for (let i=0; i<datapointAddList.length; i++) {
      datapointIds.push(datapointAddList[i]);
    }

    let reqBody = {
          datapointIds: datapointIds
        };

    return new Promise(async (resolve, reject) => {
      try {

        const res = await axiosAuth_DATA_MGMT_API.post("subs/" + subsAttrs.id + "/datapoint-ids", reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setDatapointAddList([]);
          setAddDatapointErrMsg('');
          setShowAddDatapointDialog(false);
          fetchAssociatedDatapoints(subsAttrs.id);
          setSearchTerm('');
          setDatapointCandidateList([]);
        } else {
          // ##### NEED TO DECIDE WHAT TO DO #####
        }
      } catch (error) {
        setAddDatapointErrMsg(t(translateAPIError(error)));
        return;
      }
    });
  }


  function handleRemoveDatapoint(datapoint) {

    let reqBody = {
          data: {
             "datapointIds": []
          }
        };

    reqBody.data.datapointIds.push(datapoint.id);

    return new Promise(async (resolve, reject) => {
      try {

        const res = await axiosAuth_DATA_MGMT_API.delete("subs/" + subsAttrs.id + "/datapoint-ids/", reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setErrMsg('');
          fetchAssociatedDatapoints(subsAttrs.id);
        } else {
          // ##### NEED TO DECIDE WHAT TO DO #####
        }
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
        return;
      }
    });
  }

  const handleDatapointSelect = (e) => {

    if (e.target.checked) {
      // Add datapoint to the list
      datapointAddList.push(e.target.id);
    } else {
      const index = datapointAddList.indexOf(e.target.id);
      if (index > -1) {
        datapointAddList.splice(index, 1);
      }
    }

    setDatapointAddList(datapointAddList);
  }


  function renderDatapoint(datapoint, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
{/*
        <td><span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleDatapointInfo(datapoint)}>{datapoint.name}</span></td>
*/}
        <td>{datapoint.code}</td>
        <td>{datapoint.description}</td>
        <td><span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleRemoveDatapoint(datapoint)}><BiTrash size={16} /></span></td>
      </tr>
    )
  }


  function renderDatapointCandidate(datapoint, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td><Form.Check type="checkbox" id={datapoint.id} label="" onChange={handleDatapointSelect} /></td>
        <td>{datapoint.code}</td>
        <td>{datapoint.description}</td>
      </tr>
    )
  }

  // -- ALARM TYPES --

/*
  function handleAlarmRuleInfo(alarmRule) {

    setAlarmRuleSelected(alarmRule);
    setShowAlarmRuleInfo(true);
  }

  const handleAlarmRuleInfoClose = (e) => {
    setAlarmRuleSelected(null);
    setShowAlarmRuleInfo(false);
  }
*/


  function handleAddAlarmRules() {
    searchAlarmRules();
    setShowAddAlarmRuleDialog(true);
  }

  function handleAddAlarmRulesClose() {
    setSearchTerm('');
    setAlarmRuleAddList([]);
    setShowAddAlarmRuleDialog(false);
  }

  function handleAddAlarmRulesSubmit() {
    let alarmRuleIds = [];

    if (alarmRuleAddList.length === 0) {
      setShowAddAlarmRuleDialog(false);
      return;
    }

    for (let i=0; i<alarmRuleAddList.length; i++) {
      alarmRuleIds.push(alarmRuleAddList[i]);
    }

    let reqBody = {
          alarmRuleIds: alarmRuleIds
        };

    return new Promise(async (resolve, reject) => {
      try {

        const res = await axiosAuth_DATA_MGMT_API.post("subs/" + subsAttrs.id + "/alarmrule-ids", reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setAlarmRuleAddList([]);
          setAddAlarmRuleErrMsg('');
          setShowAddAlarmRuleDialog(false);
          fetchAssociatedAlarmRules(subsAttrs.id);
          setSearchTerm('');
          setAlarmRuleCandidateList([]);
        } else {
          // ##### NEED TO DECIDE WHAT TO DO #####
        }
      } catch (error) {
        setAddAlarmRuleErrMsg(t(translateAPIError(error)));
        return;
      }
    });
  }


  function handleRemoveAlarmRule(alarmRule) {

    let reqBody = {
          data: {
             "alarmRuleIds": []
          }
        };

    reqBody.data.alarmRuleIds.push(alarmRule.id);

    return new Promise(async (resolve, reject) => {
      try {

        const res = await axiosAuth_DATA_MGMT_API.delete("subs/" + subsAttrs.id + "/alarmrule-ids", reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setErrMsg('');
          fetchAssociatedAlarmRules(subsAttrs.id);
        } else {
          // ##### NEED TO DECIDE WHAT TO DO #####
        }
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
        return;
      }
    });
  }

  const handleAlarmRuleSelect = (e) => {

    if (e.target.checked) {
      // Add alarmRule to the list
      alarmRuleAddList.push(e.target.id);
    } else {
      const index = alarmRuleAddList.indexOf(e.target.id);
      if (index > -1) {
        alarmRuleAddList.splice(index, 1);
      }
    }

    setAlarmRuleAddList(alarmRuleAddList);
  }


  function renderAlarmRule(alarmRule, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
{/*
        <td><span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleAlarmRuleInfo(alarmRule)}>{alarmRule.name}</span></td>
*/}
        <td>{alarmRule.code}</td>
        <td>{alarmRule.description}</td>
        <td><span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleRemoveAlarmRule(alarmRule)}><BiTrash size={16} /></span></td>
      </tr>
    )
  }


  function renderAlarmRuleCandidate(alarmRule, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td><Form.Check type="checkbox" id={alarmRule.id} label="" onChange={handleAlarmRuleSelect} /></td>
        <td>{alarmRule.code}</td>
        <td>{alarmRule.description}</td>
      </tr>
    )
  }

  // -- END --


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_Subs_Details")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Subs_info")}
            </span>
            {editMode ?
              null
              :
              <span style={{marginLeft:'15px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditAttrs}>
                <PencilIcon size={12} />
                {t("I18N_Edit")}
              </span>
            }
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          {editMode ?
            <Container>
              <form>
                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_Subscriber_app")}: *</Col>
                  <Col>{t("I18N_Description")}:</Col>
                  <Col>{t("I18N_IGC_username")}: *</Col>
                  <Col>{t("I18N_Status")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="subsApp"
                           value={subsAttrs.subsApp} onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="description"
                              value={subsAttrs.description} onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="igcUsername"
                           value={subsAttrs.igcUsername} onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={!subsAttrs.status || !statusOptions.find( ({ key }) => key === subsAttrs.status ) ? t("common:I18N_DROPDOWN_PROMPT") :
                              t("I18N_" + (statusOptions.find( ({ key }) => key === subsAttrs.status )).value)}
                      onSelect={onStatusSelect}>
                      {statusOptions.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                            {t("I18N_" + item.value)}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col>{t("I18N_Receiver_type")}: *</Col>
                  <Col>{t("I18N_Receiver_username")}:</Col>
                  <Col>{t("I18N_Receiver_password")}:</Col>
                  <Col></Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={!subsAttrs.receiverType ? t("common:I18N_DROPDOWN_PROMPT") :
                              (receiverTypeOptions.find( ({ key }) => key === subsAttrs.receiverType )).value}
                      onSelect={onReceiverTypeSelect}>
                      {receiverTypeOptions.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                            {item.value}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Col>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="receiverUsername"
                           value={subsAttrs.receiverUsername} onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="receiverPassword"
                           value={subsAttrs.receiverPassword} onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col></Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col sm={{span: 12}}>{t("I18N_Receiver_setting")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col sm={{span: 12}}>
                    <textarea rows={5} className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="receiverSetting"
                              value={subsAttrs.receiverSetting} onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
                  <span>{t("I18N_Req_fields")}</span>
                </Row>

                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleEditCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '15px' }}
                      onClick={handleEditSubmit}>
                      {t("I18N_Save")}
                    </Button>
                    <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                      {errMsg_Update}
                    </span>
                  </div>
                </Row>
              </form>
            </Container>
            :
            <Container>
              <Row className={classes.admin_pages__field_label}>
                <Col>{t("I18N_Subscriber_app")}:</Col>
                <Col>{t("I18N_Description")}:</Col>
                <Col>{t("I18N_IGC_username")}:</Col>
                <Col>{t("I18N_Status")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{subsAttrs.subsApp}</Col>
                <Col style={{maxHeight:'80px', overflow:'auto', flexWrap:'wrap', wordWrap:'break-word'}}>
                  {subsAttrs.description}
                </Col>
                <Col>{subsAttrs.igcUsername}</Col>
                <Col>{t("I18N_" + subsAttrs.status)}</Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Receiver_type")}:</Col>
                <Col>{t("I18N_Receiver_username")}:</Col>
                <Col>{t("I18N_Receiver_password")}:</Col>
                <Col></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{subsAttrs.receiverType}</Col>
                <Col>{subsAttrs.receiverUsername}</Col>
                <Col>{subsAttrs.receiverPassword}</Col>
                <Col></Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col sm={{span: 12}}>{t("I18N_Receiver_setting")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col sm={{span: 12}}>
                  <textarea readOnly rows={5} className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="receiverSetting"
                            value={subsAttrs.receiverSetting} onChange={(e) => onAttrsInputChange(e)} />
                </Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Created_by")}:</Col>
                <Col>{t("I18N_Time_created")}:</Col>
                <Col>{t("I18N_Updated_by")}:</Col>
                <Col>{t("I18N_Time_updated")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col style={{overflowWrap:'anywhere'}}>{subsAttrs.creatorUsername}</Col>
                <Col>{formatDate(subsAttrs.timeCreated)}</Col>
                <Col style={{overflowWrap:'anywhere'}}>{subsAttrs.updaterUsername}</Col>
                <Col>{formatDate(subsAttrs.timeUpdated)}</Col>
              </Row>

            </Container>
          }
        </div>


        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'30px'}}>
          <div style={{display:'flex'}}>
            { (subsTargetMode === 'DATAPOINTS') ?
                <>
                  <span>
                    {t("I18N_Subscribed_datapoints")}
                  </span>
                  <span style={{marginLeft:'10px', marginRight:'10px'}}>
                    {'|'}
                  </span>
                  <span style={{fontSize:'12px', marginTop:'2px', color:'SteelBlue', cursor:'pointer'}} onClick={() => handleTargetToggle('ALARRULES')}>
                    {t("I18N_Subscribed_alarm_rules")}
                  </span>
                </>
              : (subsTargetMode === 'ALARRULES') ?
                <>
                  <span style={{fontSize:'12px', marginTop:'2px', color:'SteelBlue', cursor:'pointer'}} onClick={() => handleTargetToggle('DATAPOINTS')}>
                    {t("I18N_Subscribed_datapoints")}
                  </span>
                  <span style={{marginLeft:'10px', marginRight:'10px'}}>
                    {'|'}
                  </span>
                  <span>
                    {t("I18N_Subscribed_alarm_rules")}
                  </span>
                </>
              :
                <></>
            }
            <span style={{marginLeft:'auto', marginRight:'20px'}}>
            { (subsTargetMode === 'DATAPOINTS') ?
                <OverlayTrigger overlay={<Tooltip id="tooltip-new_datapoint" style={{fontSize:'11px'}}>{t("I18N_TIP_Add_datapoint")}</Tooltip>}>
                  <span onClick={handleAddDatapoints}
                        style={{ marginLeft: '0px', marginRight: '0px', marginTop: '3px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                    <BiPlus size={18} />
                  </span>
                </OverlayTrigger>
              : (subsTargetMode === 'ALARRULES') ?
                <OverlayTrigger overlay={<Tooltip id="tooltip-new_datapoint" style={{fontSize:'11px'}}>{t("I18N_TIP_Add_alarm_rules")}</Tooltip>}>
                  <span onClick={handleAddAlarmRules}
                        style={{ marginLeft: '0px', marginRight: '0px', marginTop: '3px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                    <BiPlus size={18} />
                  </span>
                </OverlayTrigger>
              :
                <></>
            }
            </span>
          </div>

          <hr className="solid" style={{ margin: '0 0 0 0' }}></hr>

          { (subsTargetMode === 'DATAPOINTS') ?
            <div style={{overflow:'auto', fontSize:'11px', marginTop:'10px'}}>
              <Table hover responsive size="sm">
                <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                  <tr>
                    <th style={{width:"35%", fontWeight:'400'}}>{t("I18N_Datapoint_code")}</th>
                    <th style={{width:"65%", fontWeight:'400'}}>{t("I18N_Description")}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {(datapointList && datapointList.length > 0) ? datapointList.map(renderDatapoint) : null}
                </tbody>
              </Table>
            </div>
          : (subsTargetMode === 'ALARRULES') ?
            <div style={{overflow:'auto', fontSize:'11px', marginTop:'10px'}}>
              <Table hover responsive size="sm">
                <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                  <tr>
                    <th style={{width:"35%", fontWeight:'400'}}>{t("I18N_Code")}</th>
                    <th style={{width:"65%", fontWeight:'400'}}>{t("I18N_Description")}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {(alarmRuleList && alarmRuleList.length > 0) ? alarmRuleList.map(renderAlarmRule) : null}
                </tbody>
              </Table>
            </div>
          :
            <></>
          }
        </div>



        <hr className="solid" style={{ marginTop: '30px' }}></hr>

        <div className={classes.admin_pages__page_subtitle} >
          <Form.Group as={Row} className="mb-2 mt-3">
            <div style={{ display: "flex" }}>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ fontSize:'12px', fontWeight:'300' }}
                onClick={handleClose}>
                {t("I18N_Close")}
              </Button>
              <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)', verticalAlign: 'top', marginLeft: '0' }}>
                {errMsg}
              </span>
            </div>
          </Form.Group>
        </div>


        <Modal show={showAddDatapointDialog} onHide={handleAddDatapointsClose} centered >
          <Modal.Body>
            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
              <div style={{ display: 'flex' }}>
                <span>
                  {t("I18N_Datapoints")}
                </span>
                <span style={{ marginLeft: 'auto', marginRight: '0px', width: '220px' }}>
                  <Form onSubmit={handleSearchDatapointsSubmit}>
                    <Form.Group as={Row} >
                      <Col sm={10} style={{ marginRight: '0px', paddingRight: '0px' }}>
                        <Form.Control style={{ fontSize: '12px' }} type="text" name="searchTerm" value={searchTerm ? searchTerm : ''}
                                      onChange={(e) => onSearchInputChange(e)} placeholder={t("I18N_Search_datapoint")} />
                      </Col>
                      <Col sm={1} style={{ paddingTop: '5px' }}>
                        <OverlayTrigger overlay={<Tooltip id="tooltip-search_datapoints" style={{fontSize:'11px'}}>
                                                 {t("I18N_TIP_Search_datapoints")}</Tooltip>}>
                          <span onClick={handleSearchDatapointsSubmit} style={{ cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                            <SearchIcon size={18} />
                          </span>
                        </OverlayTrigger>
                      </Col>
                    </Form.Group>
                  </Form>
                </span>
              </div>

            </div>

            <div style={{overflow:'auto', fontSize:'11px', marginTop:'10px', maxHeight:'600px'}}>
              <Table hover responsive size="sm">
                <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                  <tr>
                    <th></th>
                    <th style={{fontWeight:'400'}}>{t("I18N_Datapoint_code")}</th>
                    <th style={{fontWeight:'400'}}>{t("I18N_Description")}</th>
                  </tr>
                </thead>
                <tbody>
                  {(datapointCandidateList && (datapointCandidateList.length > 0))? datapointCandidateList.map(renderDatapointCandidate) : null}
                </tbody>
              </Table>
            </div>

            <div display='flex' style={{ marginTop: '15px' }}>
              <Button size="tiny" variant="outline-secondary" className="mb-3"
                style={{ float: 'left' }}
                onClick={handleAddDatapointsClose}>
                {t("I18N_Cancel")}
              </Button>
              <Button size="tiny" variant="outline-secondary" className="mb-3"
                style={{ marginLeft: '15px' }}
                onClick={handleAddDatapointsSubmit}>
                {t("I18N_Add_datapoints")}
              </Button>
            </div>

            { addDatapointErrMsg && (addDatapointErrMsg.length > 0) ?
              <div>
                <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                  {addDatapointErrMsg}
                </span>
              </div>
            :
              <></>
            }

          </Modal.Body>
        </Modal>


        <Modal show={showAddAlarmRuleDialog} onHide={handleAddAlarmRulesClose} centered >
          <Modal.Body>
            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
              <div style={{ display: 'flex' }}>
                <span>
                  {t("I18N_Alarm_rules")}
                </span>
                <span style={{ marginLeft: 'auto', marginRight: '0px', width: '220px' }}>
                  <Form onSubmit={handleSearchAlarmRulesSubmit}>
                    <Form.Group as={Row} >
                      <Col sm={10} style={{ marginRight: '0px', paddingRight: '0px' }}>
                        <Form.Control style={{ fontSize: '12px' }} type="text" name="searchTerm" value={searchTerm ? searchTerm : ''}
                                      onChange={(e) => onSearchInputChange(e)} placeholder={t("I18N_Search_alarm_rule")} />
                      </Col>
                      <Col sm={1} style={{ paddingTop: '5px' }}>
                        <OverlayTrigger overlay={<Tooltip id="tooltip-search_alarm_rules" style={{fontSize:'11px'}}>
                                                 {t("I18N_TIP_Search_alarm_rules")}</Tooltip>}>
                          <span onClick={handleSearchAlarmRulesSubmit} style={{ cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                            <SearchIcon size={18} />
                          </span>
                        </OverlayTrigger>
                      </Col>
                    </Form.Group>
                  </Form>
                </span>
              </div>

            </div>

            <div style={{overflow:'auto', maxHeight:'500px', fontSize:'11px', marginTop:'10px'}}>
              <Table hover responsive size="sm">
                <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                  <tr>
                    <th></th>
                    <th style={{fontWeight:'400'}}>{t("I18N_Code")}</th>
                    <th style={{fontWeight:'400'}}>{t("I18N_Description")}</th>
                  </tr>
                </thead>
                <tbody>
                  {(alarmRuleCandidateList && (alarmRuleCandidateList.length > 0)) ? alarmRuleCandidateList.map(renderAlarmRuleCandidate) : null}
                </tbody>
              </Table>
            </div>

            <div display='flex' style={{ marginTop: '15px' }}>
              <Button size="tiny" variant="outline-secondary" className="mb-3"
                style={{ float: 'left' }}
                onClick={handleAddAlarmRulesClose}>
                {t("I18N_Cancel")}
              </Button>
              <Button size="tiny" variant="outline-secondary" className="mb-3"
                style={{ marginLeft: '15px' }}
                onClick={handleAddAlarmRulesSubmit}>
                {t("I18N_Add_alarm_rule")}
              </Button>
            </div>

            { addAlarmRuleErrMsg && (addAlarmRuleErrMsg.length > 0) ?
              <div>
                <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                  {addAlarmRuleErrMsg}
                </span>
              </div>
            :
              <></>
            }


          </Modal.Body>
        </Modal>

      </Card>
    </>
  );
}

export default SubsAdminDetailsView;
